/* src/templates/4/assets/css/main.css */
html {
  overflow-y: scroll;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  background: #fff;
  color: #333;
  font: .875em/1.5 FreeSans, sans-serif;
  margin: 0;
  min-height: 100%;
}
.templateContainer {
  margin: 0 auto;
  max-width: 960px;
  padding: 0 1%;
}
.header {
  background: #fff;
  color: #333;
  margin-bottom: 1.5em;
}
.siteLogo {
  color: #fff;
  display: block;
  float: left;
  font-size: 1.286em;
  font-weight: 700;
  height: 84px;
  line-height: 1.125;
  margin-top: 10px;
  padding: 1em .2em 1em 3;
  text-decoration: none;
  vertical-align: middle;
  transition: .2s linear;
}
.siteLogo:hover,
.siteLogo:focus {
  background: #fff;
  background: rgba(200, 200, 200, .2);
  color: #000;
}
.siteLogo > .left {
  margin: 0 10px 0 0;
}
.siteLogo > span {
  font-weight: 300;
  color: #002664;
  display: inline-block;
  font-size: 2.2em;
  height: 54px;
  line-height: 54px;
  margin-top: .4em;
  padding-left: 10px;
  vertical-align: middle;
}
.siteLogo > span > strong {
  color: #002664;
  font-weight: 900;
  letter-spacing: -0.05em;
}
.topNav,
.forYou > ul,
.hNav ul,
.vNav,
.vNav ul,
.footer ul {
  list-style: none;
  padding: 0;
}
.topNav {
  float: right;
}
.topNav > li {
  float: left;
  margin-left: 2em;
}
.topNav > li:first-child {
  font-weight: 700;
  margin-left: 0;
}
.topNav > li > a {
  border-radius: 4px;
  line-height: 2;
  padding: 0 .5em;
  transition: background .15s linear;
}
.topNav .here {
  background: #111;
}
.topNav a,
.topNav a:hover,
.topNav a:focus {
  color: #001F3F;
  display: block;
  text-decoration: none;
}
.topNav a:hover,
.topNav a:focus {
  background: #353535;
  color: #fff;
}
.forYou {
  position: relative;
}
.forYou > a {
  background: #444;
  color: #fff;
  font-weight: 700;
}
.forYou:hover > a,
.forYou > a:focus,
.forYou > .descendantFocus {
  background: #353535;
  border-radius: 4px 4px 0 0;
}
.forYou > ul {
  background: #fff;
  background: rgba(255, 255, 255, .98);
  border: 3px solid #353535;
  border-radius: 4px 0 4px 4px;
  display: none;
  margin: 0;
  padding: 10px;
  position: absolute;
  right: 0;
  z-index: 101;
}
.forYou:hover ul,
.forYou > a:focus + ul,
.forYou > .descendantFocus + ul {
  display: block;
}
.forYou > ul a {
  border-bottom: 1px solid #ddd;
  border-radius: 3px;
  color: #333;
  padding: 5px;
  transition: none;
}
.forYou > ul a:hover,
.forYou > ul a:focus {
  background: #353535;
  color: #fff;
}
.forYou li {
  white-space: pre;
}
.forYou .more > a {
  border-bottom: 0;
}
.header form {
  clear: right;
  color: #333;
  float: right;
}
.header label {
  color: #fff;
}
.header input {
}
.header button {
  background: #f2f2f2;
  background:
    linear-gradient(
      #f2f2f2,
      #ebebeb 50%,
      #ddd 50%,
      #cfcfcf);
  border: 1px solid #979ea1;
  border-radius: 4px;
  box-shadow: none;
  color: #005690;
  text-shadow: none;
}
.header button:hover,
.header button:active,
.header button:focus {
  background: inherit;
  background:
    linear-gradient(
      #f2f2f2,
      #ebebeb 50%,
      #ddd 50%,
      #cfcfcf);
}
#q {
  position: relative;
  transition: width .2s linear;
  width: 21.4286em;
  z-index: 100;
}
.hNav {
  background: #E7E7E7;
  border-bottom: 1px solid #CACACA;
}
.hNav > ul {
  bottom: 4px;
  display: table;
  margin: 0 auto -5px;
  position: relative;
}
.hNav > ul > li {
  float: left;
  position: relative;
  transition: .2s linear;
}
.hNav > ul > li > a {
  border-top: .25em solid transparent;
  color: #333;
  display: block;
  font-size: 1.143em;
  font-weight: 700;
  line-height: 3.1875;
  padding: 0 13px;
  text-decoration: none;
  transition: .1s linear;
}
.hNav > ul:hover > li > a {
  border-color: #fff;
}
.hNav > ul > li:not(.here) > a {
  transition: background .2s linear;
}
.hNav > ul > li:hover > a,
.hNav > ul > li > a:focus,
.hNav > ul > li > .descendantFocus {
  background: #CACACA;
  border-color: #fff;
  color: #000;
}
.hNav > ul > .here > a,
.hNav > ul > .here > a:focus,
.hNav > ul > .here > .descendantFocus {
  background: #BBB;
  background-clip: padding-box;
  border-radius: 6px 6px 0 0;
  border-top: none;
  line-height: 3.4375;
  color: #000;
  transition: none;
}
.hNav > ul > .here:hover > a,
.hNav > ul > .here > .descendantFocus,
.hNav > ul > .here > .descendantFocus:focus {
  background: #CACACA;
}
.hNav > ul > li > div {
  background: #fff;
  background: rgba(255, 255, 255, .98);
  border: 1px solid #E2E4E4;
  border-top-color: transparent;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 0 4px 2px rgba(51, 51, 51, .1);
  display: none;
  left: 0;
  position: absolute;
  width: 440px;
  z-index: 101;
}
.hNav > ul > :first-child > div,
.hNav > ul > :last-child > div {
  width: 220px;
}
.hNav > ul > :nth-child(6) > div,
.hNav > ul > :last-child > div {
  left: auto;
  right: 0;
}
.hNav > ul > li:hover > div,
.hNav > ul > li > a:focus + div,
.hNav > ul > li > .descendantFocus + div {
  display: block;
}
.hNav > ul > li > div > ul {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 10px;
  width: 220px;
}
.hNav > ul > li > .twoColumn > ul {
  float: left;
}
.hNav > ul > li > div li {
  border-top: 1px solid #ddd;
}
.hNav > ul > li > div :first-child {
  border-top: 0;
}
.hNav > ul > li > div a {
  border-radius: 3px;
  color: #111;
  display: block;
  padding: 5px 5px;
  text-decoration: none;
  transition: none;
}
.hNav > ul > li > div a:hover,
.hNav > ul > li > div a:focus {
  background: #CACACA;
  color: #000;
}
.vNav {
  float: left;
  margin: 0 20px 0 0;
  width: 180px;
}
.vNav a {
  border-top: 1px solid #ededed;
  display: block;
  padding: .385em 0;
}
.vNav .here {
  background: #fff url("./media/arrow_right_gray_17x14.png") 100% 50% no-repeat;
  color: #333;
  font-weight: 700;
  padding-right: 18px;
}
.vNav > li > a {
  border: 0;
  display: block;
  font-size: 1.286em;
  font-weight: 700;
  line-height: 1.1666;
  padding: 0 0 6px;
}
.vNav > li > .here {
  background-position: 100% 6px;
}
.vNav > li > ul:first-child {
  margin-top: 30px;
}
.vNav ul {
  font-size: .929em;
  margin: 0;
}
.vNav ul ul {
  background: #f5f5f5;
  font-size: .923em;
}
.vNav ul ul > li > a {
  padding-left: 1em;
  padding-right: .25em;
}
.vNav ul ul ul {
  background: rgba(255, 255, 255, .5);
  font-size: .916em;
  margin-left: 1em;
}
.vNav ul ul ul ul {
  background: rgba(255, 255, 255, .5);
  font-size: .909em;
}
.mainColumn {
  float: right;
  padding-bottom: 2.5em;
  position: relative;
  width: 760px;
}
.noSidebars > .mainColumn,
.noLeftSidebar > .mainColumn {
  float: none;
  width: auto;
}
.breadcrumbs {
  font-size: .929em;
  margin: 0 0 10px;
  padding-left: 1px;
}
.hGroup {
  border-top: 1px solid #ededed;
  float: left;
  margin-bottom: 10px;
  padding-top: 10px;
}
.hGroup.tall {
  min-height: 53px;
}
.templateContainer #content {
  clear: both;
  float: left;
}
.default #content,
.default .hGroup,
.noRightSidebar .hGroup {
  width: 520px;
}
.noLeftSidebar #content,
.noLeftSidebar .hGroup,
.noSidebars .hGroup {
  float: left;
  width: 720px;
}
.noRightSidebar #content,
.noSidebars #content {
  width: 100%;
}
.pageTitle {
  letter-spacing: -1px;
  line-height: 1.0714;
  margin: .107em 0;
}
.pageSubtitle {
  color: #444;
  font-size: 1.714em;
  letter-spacing: -1px;
  line-height: 1.167;
  margin: .083em 0;
}
.rightSidebar {
  float: right;
  margin-left: 20px;
  min-height: 1px;
  overflow: hidden;
  width: 220px;
}
.pod {
  background: #F8F8F8;
  border: 1px solid #d9dcdf;
  margin: 1.5em 0 .214em;
}
.pod > h2 {
  background: #003E7E;
  color: #fff;
  margin: -1px -1px 0 -1px;
  padding: .25em;
}
.pod > h2 > a,
.pod > h2 > a:focus,
.pod > h2 > a:hover {
  color: #fff;
}
.pod.alt > h2 {
  background: #0076C0;
}
.pod.alt2 > h2 {
  background: #353535;
}
.pod > div {
  padding: 1px 5px;
}
.rightSidebar > .pod > ul {
  list-style: none;
  margin-top: .214em;
  padding: 5px;
}
.rightSidebar > .pod li {
  padding: 3px 0;
}
.footer {
  background: #e6e6e6;
  background: linear-gradient(#efefef, #e6e6e6);
  border-top: 2px solid #e3e3e3;
  font-size: .929em;
  padding: 1.5em 0 3em;
}
.footer ul {
  margin-top: .214em;
}
.footer h2 {
  font-size: 1.385em;
}
.footer h2:first-child {
  margin-top: 0;
}
.footer a {
  color: #2353BA;
}
.footer > div > div {
  min-width: 112px;
  width: 12%;
}
.footer > div > div + div {
  width: 42%;
}
.footer > div > div + div > div {
  width: 48%;
}
.footer > div > div + div > div + div {
  width: 48%;
}
.footer > div > div + div + div > div {
  width: 48%;
}
.footer > div > div + div + div > div + div {
  width: 48%;
}
.footerLogo {
  color: #fff;
  display: block;
  float: left;
  font-size: 1em;
  font-weight: 700;
  line-height: 1;
  padding-right: .2em;
  text-decoration: none;
  vertical-align: middle;
  transition: .2s linear;
}
.footerLogo > span {
  color: #005bbb;
  display: inline-block;
  font-size: 2.2em;
  line-height: 1;
  padding: .2em;
  vertical-align: middle;
  word-spacing: -0.3em;
}
.footerLogo > span > strong {
  color: #002664;
  font-weight: 900;
  letter-spacing: -0.05em;
}
.readersViewers > li {
  display: inline-block;
  margin-left: .5em;
  vertical-align: bottom;
}
.readersViewers > li:first-child {
  margin-left: 0;
}
.readersViewers a {
  background: url("./media/readersViewersSprite.png") no-repeat;
  display: block;
  height: 20px;
  width: 20px;
}
.readersViewers .doc {
  background-position: -20px 0;
}
.readersViewers .xls {
  background-position: -40px 0;
}
.readersViewers .ppt {
  background-position: -60px 0;
}
.readersViewers .zip {
  background-position: -80px 0;
}
.faaBar {
  background: #002663;
  background: linear-gradient(#002663, #000933);
  border: 1px solid #002663;
  border-radius: 10px;
  display: block;
  font-size: 1.1581em;
  font-weight: 700;
  height: 80px;
  margin-top: 1em;
  width: auto;
}
.faaBar > a {
  background: url("./media/footerSeal.png") left center no-repeat;
  display: inline-block;
  height: 53px;
  margin: 14px 0 14px 28px;
  padding-left: 60px;
}
.faaBar > a > span {
  color: #fff;
  display: inline-block;
  line-height: 1.257;
  margin-top: 8px;
  width: 8.5em;
}
address,
h2,
h3,
h4,
h5,
h6,
hr,
p,
ul,
ol,
dl,
dt,
form,
table {
  margin: 1.5em 0 .214em;
}
blockquote {
  background: #F6F6F6;
  border-radius: 3px;
  margin: 1.5em;
  padding: 1em;
}
blockquote > p:first-child {
  margin-top: .214em;
}
center {
  text-align: inherit;
}
h2 {
  font-size: 1.429em;
  line-height: 1.2;
}
h3 {
  font-size: 1.143em;
  line-height: 1.3125;
}
h5 {
  font-size: .929em;
}
h6 {
  font-size: .857em;
}
hr {
  border: 1px solid #808080;
  border-width: 1px 0 0;
  box-sizing: content-box;
  clear: both;
  height: 0;
  overflow: visible;
}
.heavy {
  border-width: 2px 0;
}
a {
  background-color: transparent;
}
a,
.ui-state-default,
.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited,
.ui-widget-content a {
  color: #005690;
  text-decoration: none;
  transition: color .2s linear;
}
.diagnosticLink {
  background: #005690;
}
a:focus {
  outline: 1px dotted #808080;
}
a:hover,
a:focus,
.ui-state-default.ui-state-hover,
.ui-state-default a:hover,
.ui-state-default a:focus,
.ui-state-default a:link:hover,
.ui-state-default a:link:focus,
.ui-state-default a:visited:hover,
.ui-state-default a:visited:focus,
.ui-widget-content a:hover,
.ui-widget-content a:focus {
  color: #000;
}
.diagnosticHover {
  background: #000;
}
a:hover,
a:active,
.ui-state-default.ui-state-hover {
  outline: 0;
  text-decoration: underline;
}
abbr[title],
acronym[title] {
  border-bottom: 1px dotted;
  cursor: help;
  text-decoration: none;
}
a abbr[title],
a acronym[title] {
  cursor: pointer;
}
a:hover abbr[title],
a:focus abbr[title],
a:hover acronym[title],
a:focus acronym[title] {
  border-bottom: 0;
}
[align] {
  float: none;
  text-align: inherit;
}
[align],
[valign] {
  vertical-align: initial;
}
td[valign] {
  vertical-align: top;
}
b,
.bold,
strong {
  font-weight: 700;
}
basefont,
font {
  color: inherit;
  font: inherit;
}
big {
  font-size: inherit;
}
del {
  color: #595959;
}
dfn {
  font-style: italic;
}
code,
kbd,
pre,
samp {
  font-family:
    Consolas,
    Monaco,
    monospace,
    monospace;
  font-size: 1em;
  -moz-tab-size: 5;
  tab-size: 5;
  white-space: pre-wrap;
}
code,
samp {
  background: #eee;
  border-radius: 3px;
  padding: 3px;
}
kbd {
  background: #333;
  border: .4em solid #222;
  border-left-color: #111;
  border-right-color: #111;
  border-radius: .3em;
  color: #eee;
  font: .857em Arial, sans-serif;
  padding: 0 .4em .4em .2em;
  position: relative;
  top: -.2em;
}
[hspace] {
  margin-left: 0;
  margin-right: 0;
}
[vspace] {
  margin-bottom: 0;
  margin-top: 0;
}
q {
  quotes: "\201c" "\201d" "\2018" "\2019";
}
::-moz-selection {
  background: #b3d4fc;
  color: #333;
  text-shadow: none;
}
::selection {
  background: #b3d4fc;
  color: #333;
  text-shadow: none;
}
samp {
  background: #333;
  color: #01FF70;
}
small,
.small {
  font-size: .857em;
}
strike {
  text-decoration: inherit;
}
sub,
sup {
  font-size: .786em;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
var {
  color: #85144B;
}
ol,
ul {
  padding-left: 2em;
}
ol ol > li {
  list-style-type: lower-alpha;
}
ol ol ol > li {
  list-style-type: lower-roman;
}
li ul,
li ol {
  margin-top: .214em;
}
.oversized > li {
  margin: 1.5em 0 .214em;
}
.oversized.join > li:first-child {
  margin-top: .214em;
}
.more {
  font-size: .929em;
  font-weight: 400;
  list-style: none;
  margin-top: .5em;
}
.more > a {
  font-weight: 700;
}
dt {
  font-weight: 700;
}
dt:first-child {
  margin-top: .214em;
}
dd {
  margin-left: 2em;
}
img {
  border: 0;
}
img:not([usemap])[width][height],
img:not([usemap]):not([height]) {
  height: auto;
  max-width: 100%;
}
img.border {
  border: 1px solid #333;
}
img.left {
  float: left;
  margin: .25em 1em 1em 0;
}
img.right {
  float: right;
  margin: .25em 0 1em 1em;
}
.image {
  margin: 1.5em 0 .214em;
}
.image > img {
  border: 1px solid #333;
  display: block;
}
.image.s2 > img {
  border: none;
}
.image.s2,
.image.s3 {
  background: #F3F6F6;
  border: 1px solid #333;
  padding: 2px;
}
.image > .caption {
  font-size: .929em;
  font-style: italic;
}
div.left {
  float: left;
  margin-bottom: 1em;
  margin-right: 1.5em;
}
div.center {
  margin-left: auto;
  margin-right: auto;
}
div.right {
  float: right;
  margin-bottom: 1em;
  margin-left: 1.5em;
}
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: .35em .625em .75em;
}
legend {
  border: 0;
  padding: 0;
}
button,
input,
optgroup,
select,
textarea {
  color: #333;
  font-family: inherit;
  font-size: 100%;
  margin: 0;
}
button,
input {
  line-height: normal;
}
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button;
  cursor: pointer;
}
button:disabled,
html input:disabled {
  cursor: default;
}
input[type=checkbox],
input[type=radio] {
  border: 0;
  box-sizing: border-box;
  min-height: 1.5em;
  padding: 0;
}
input[type=search] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
textarea {
  line-height: 1.5;
  min-height: 4.5em;
  min-width: 9em;
  overflow: auto;
  resize: vertical;
  vertical-align: top;
}
::-webkit-input-placeholder {
  color: #595959;
  font-style: italic;
}
:-moz-placeholder {
  color: #595959;
  font-style: italic;
}
::-moz-placeholder {
  color: #595959;
  font-style: italic;
}
:-ms-input-placeholder {
  color: #595959;
  font-style: italic;
}
.placeholder {
  color: #595959;
  font-style: italic;
}
label {
  vertical-align: top;
}
label[for] {
  cursor: pointer;
}
button,
input,
textarea {
  padding: 2px 3px;
}
select {
  padding: 1px;
}
button,
input,
select,
textarea {
  border: 1px solid #ccc;
  max-width: 100%;
  text-transform: none;
  vertical-align: top;
}
input:hover,
select:hover,
textarea:hover {
  border-color: #C0C0C0;
  box-shadow: 0 0 4px rgba(0, 0, 0, .1);
}
input:focus,
select:focus,
textarea:focus {
  border-color: #BBB;
  box-shadow: 0 0 4px rgba(0, 0, 0, .2);
}
a.button {
  background: #005690;
  border: 1px solid #005690;
  border-radius: 3px;
  color: #FFF;
  display: inline-block;
  padding: .2em .5em;
  vertical-align: top;
  white-space: nowrap;
}
a.button:hover,
a.button:focus {
  text-decoration: underline;
}
button,
input[type=button],
input[type=reset],
input[type=submit] {
  background: #005991;
  background: linear-gradient(#0066A6, #005991);
  border: 1px solid #005991;
  border-radius: 3px;
  box-shadow: 0 1px 0 rgba(255, 255, 255, .2) inset, 0 1px 2px rgba(0, 0, 0, .5);
  color: #fff;
  font-weight: 700;
  padding: 2px .5em;
  text-shadow: 0 -1px 0 #023B83;
}
button:hover,
button:focus,
input[type=button]:hover,
input[type=button]:focus,
input[type=reset]:hover,
input[type=reset]:focus,
input[type=submit]:hover,
input[type=submit]:focus {
  background: #1B84C8;
  background: linear-gradient(#0066A6, #1B84C8);
}
button:active,
input[type=button]:active,
input[type=image]:active,
input[type=reset]:active,
input[type=submit]:active {
  background: #023B83;
  box-shadow: none;
}
input[type=image] {
  border: 0;
  padding: 0;
}
button.secondary,
input.secondary {
  background: #C6DAF1;
  background: linear-gradient(#F0F4F8, #C6DAF1);
  border: 1px solid #B9CCE3;
  box-shadow: none;
  color: #2A547A;
  text-shadow: 0 1px 0 #FFF;
  font-weight: 400;
}
button.secondary:hover,
button.secondary:focus,
input.secondary:hover,
input.secondary:focus {
  background: #D2E3F6;
  background: linear-gradient(#F0F4F8, #D2E3F6);
}
button:disabled,
button:disabled:hover,
input:disabled,
input:disabled:hover,
select:disabled,
select:disabled:hover,
textarea:disabled,
textarea:disabled:hover {
  background: #e6e6e6;
  border-color: #ababab;
  box-shadow: none;
  color: #666;
  cursor: default;
  text-shadow: none;
}
input[readOnly],
select[readOnly],
textarea[readOnly] {
  background: 0;
  border-color: transparent;
  box-shadow: none;
  cursor: text;
  text-overflow: ellipsis;
}
input[readOnly]:hover,
input[readyOnly]:focus,
select[readyOnly]:hover,
select[readOnly]:focus,
textarea[readOnly]:hover,
textarea[readOnly]:focus {
  box-shadow: none;
}
optgroup {
  font-style: normal;
  padding-bottom: 4px;
}
optgroup:before {
  color: #666;
}
optgroup > option {
  padding-left: 1em;
}
option:hover,
option:focus {
  background: #39f;
  color: #fff;
  cursor: pointer;
}
.layout span.required {
  color: #A00;
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1;
  margin-right: 2px;
  position: relative;
  top: 3px;
}
:-moz-ui-invalid {
  box-shadow: none;
  outline: 2px solid #A00;
}
.layout .formRow {
  border: 1px solid transparent;
  clear: both;
  overflow: hidden;
  padding: 4px;
}
.layout .formRow.noLabel {
  padding-left: 161px;
}
.layout fieldset .formRow.noLabel {
  padding-left: 160px;
}
.layout.striped .formRow:nth-child(odd) {
  background: #fff;
}
.layout.striped .formRow:nth-child(even) {
  background: #f6f6f6;
}
.layout .formRow.altBg {
  background: #f6f6f6;
}
.layout fieldset {
  border: 1px solid transparent;
  border-radius: 3px;
  clear: both;
  margin: .5em 0;
  padding: 0;
}
.layout fieldset.border {
  border-color: #c0c0c0;
}
.layout legend {
  font-size: 1.071em;
  font-weight: 700;
  margin-left: 10px;
  padding: 0 10px;
}
.layout .legend {
  border-bottom: 1px solid #999;
  font-size: 1.071em;
  font-weight: 700;
  margin-top: 2px;
  padding: 5px 20px;
}
.layout legend ~ fieldset legend,
.layout .legend ~ fieldset .legend {
  font-size: 1em;
  font-weight: 400;
}
.layout label {
  display: inline-block;
  margin-right: 3px;
  text-align: right;
  width: 150px;
}
.layout label.secondary {
  font-size: .929em;
  margin-left: 3px;
  text-align: left;
  width: auto;
}
.layout .caption {
  display: block;
  font-size: .929em;
  font-style: italic;
  margin-left: 157px;
}
.layout .noLabel .caption {
  margin-left: 0;
}
.layout label + input,
.layout label + select,
.layout label + textarea {
  max-width: 340px;
}
.noLeftSidebar .layout label + input,
.noLeftSidebar .layout label + select,
.noLeftSidebar .layout label + textarea {
  max-width: 540px;
}
.noRightSidebar .layout label + input,
.noRightSidebar .layout label + select,
.noRightSidebar .layout label + textarea {
  max-width: 580px;
}
.noSidebars .layout label + input,
.noSidebars .layout label + select,
.noSidebars .layout label + textarea {
  max-width: 780px;
}
.layout .optionGroup {
  clear: both;
  padding: 4px 4px 4px 161px;
}
.layout fieldset .formRow {
  padding: 4px 3px;
}
.layout fieldset .optionGroup {
  padding: 4px 3px 4px 160px;
}
.layout .optionGroup legend {
  margin-left: -151px;
}
.layout .optionGroup label {
  margin: 0 2px;
  text-align: left;
  width: 325px;
}
.noLeftSidebar .layout .optionGroup label {
  width: 525px;
}
.noRightSidebar .layout .optionGroup label {
  width: 565px;
}
.noSidebars .layout .optionGroup label {
  width: 765px;
}
.layout .optionGroup span.label {
  display: inline-block;
  margin-left: -157px;
  margin-right: 3px;
  text-align: right;
  vertical-align: top;
  width: 150px;
}
table {
  border: 1px solid #888;
  border-collapse: collapse;
  border-spacing: 0;
}
table.strict {
  table-layout: fixed;
  width: 100%;
}
td,
th {
  background: #FFF;
  padding: 4px 6px;
  text-align: left;
  vertical-align: top;
}
caption {
  font-weight: 700;
  text-align: left;
}
caption.header {
  background-color: #4D4D4D;
  border: 1px solid #808080;
  color: #FFF;
  margin-bottom: 0;
  text-align: center;
}
thead > tr > th {
  background: #0B4E97;
  background: linear-gradient(#084890, #084080);
  border: 1px solid #808080;
  color: #fff;
}
thead > tr + tr > th {
  background: #99CCFF;
  background: linear-gradient(#90C8F8, #78B8F8);
}
thead > tr + tr + tr th {
  background: #CCE6FF;
  background: linear-gradient(#C8E0F8, #B0D8F8);
  color: #333;
}
thead > tr > td a,
thead > tr > th a,
tfoot > tr > td a,
tfoot > tr > th a,
thead > tr > td a:hover,
thead > tr > th a:hover,
tfoot > tr > td a:hover,
tfoot > tr > th a:hover,
thead > tr > td a:focus,
thead > tr > th a:focus,
tfoot > tr > td a:focus,
tfoot > tr > th a:focus {
  color: #fff;
}
tbody > tr > td,
tbody > tr > th {
  border: 1px solid #aaa;
}
tbody > tr > th {
  font-weight: 700;
}
tbody > .altBg > td,
tbody > .altBg > th,
tbody > .alt-bg > td,
tbody > .alt-bg > th {
  background: #E8E8E8;
  background: linear-gradient(#ECECEC, #E0E0E0);
}
.striped > tbody > tr:nth-child(even) > td,
.striped > tbody > tr:nth-child(even) > th {
  background: #E8E8E8;
  background: linear-gradient(#ECECEC, #E0E0E0);
}
.hover > tbody > tr:hover > td,
.hover > tbody > tr:focus > td,
.hover > tbody > tr:hover > th,
.hover > tbody > tr:focus > th {
  background: #FCF4B1;
  background: linear-gradient(#F8F0A8, #F8F098);
}
tfoot > tr > td,
tfoot > tr > th {
  background: #0B4E97;
  background: linear-gradient(#084890, #084080);
  border: 1px solid #808080;
  color: #fff;
  font-size: .929em;
  font-weight: 700;
}
tfoot > tr:first-child > td,
tfoot > tr:first-child > th {
  border-top: 2px solid #0076c0;
}
table.centered td,
table.centered th,
tr.centered > td,
tr.centered > th,
td.centered,
th.centered {
  text-align: center;
}
table.left td,
table.left th,
tr.left > td,
tr.left > th,
td.left,
th.left {
  text-align: left;
}
table.right td,
table.right th,
tr.right > td,
tr.right > th,
td.right,
th.right {
  text-align: right;
}
.alert {
  color: #a00;
}
.clear:before,
.clear:after {
  content: " ";
  display: table;
}
.clear:after {
  clear: both;
}
.descendantImage {
  background: none;
  padding-right: 0;
}
.diagnostic {
  list-style: none;
  overflow: hidden;
  padding-left: 0;
}
.diagnostic > li {
  border-radius: 3px;
  color: #fff;
  float: left;
  line-height: 100px;
  margin-right: 1px;
  padding: 0 30px;
  text-align: center;
}
.hide,
.hidden,
[hidden],
.columnSplit {
  display: none;
}
.visuallyHidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  transition: .4s linear;
  width: 1px;
}
.header > .visuallyHidden {
  background: #001F3F;
  color: #fff;
}
.header > .visuallyHidden:focus {
  clip: auto;
  height: auto;
  left: 0;
  margin: 0;
  padding: 6px;
  top: 10px;
  width: auto;
}
p.center {
  text-align: center;
}
p.right {
  text-align: right;
}
.noJS .maxMeasure {
  max-width: 520px;
}
.modal.search {
  background: url("./media/search_16x16.png") 100% 50% no-repeat;
  padding-right: 20px;
}
.roundAll {
  border-radius: 6px;
}
.roundBottom {
  border-radius: 0 0 6px 6px;
}
.roundLeft {
  border-radius: 6px 0 0 6px;
}
.roundRight {
  border-radius: 0 6px 6px 0;
}
.roundTop {
  border-radius: 6px 6px 0 0;
}
.twoColumn::after {
  clear: both;
  content: " ";
  display: table;
}
.twoColumn > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  width: 47.308%;
  width: -webkit-calc(50% - 1em);
  width: -moz-calc(50% - 1em);
  width: calc(50% - 1em);
}
.twoColumn > div + div {
  float: right;
}
.threeColumn::after {
  clear: both;
  content: " ";
  display: table;
}
.threeColumn > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  width: 30.641%;
  width: -webkit-calc(33.333% - 1em);
  width: -moz-calc(33.333% - 1em);
  width: calc(33.333% - 1em);
}
.threeColumn > div:first-child + div {
  margin-left: 1.5em;
}
.threeColumn > div + div + div {
  float: right;
}
.uppercase,
.allCaps {
  text-transform: uppercase;
}
a[href^="/exit/"] {
  background: url(data:image/gif;base64,R0lGODlhCgAKALMKAP///yZWvStbwqnE/1OD6qzG/ypawWOT+lKC6WKS+f///wAAAAAAAAAAAAAAAAAAACH5BAEAAAoALAAAAAAKAAoAAAQvUEklqp3kgA3EpAgnBGQgFGKwCQMwEJ3KuoaRjEBxDKNCKKqcABCYBDlFSWk5iQAAOw==) no-repeat scroll 100% 50% transparent;
  padding-right: 13px;
}
a.anchorUp,
a.anchor-up,
a.anchorDown,
a.anchor-down {
  background: 0 50% no-repeat;
  padding-left: 11px;
}
a.anchorUp,
a.anchor-up,
.anchor-up > li,
.anchorUp > li {
  background-image: url(data:image/gif;base64,R0lGODlhBwAIAIABAAA+fv///yH5BAEAAAEALAAAAAAHAAgAAAIMjGGJeBoMk3SzvlQAADs=);
}
a.anchorDown,
a.anchor-down,
.anchor-down > li,
.anchorDown > li {
  background-image: url(data:image/gif;base64,R0lGODlhBwAIAIABAAA+fv///yH5BAEAAAEALAAAAAAHAAgAAAIMjGGpissHW5BIQlMAADs=);
}
ul[class^=anchor] {
  list-style: none;
  padding-left: 0;
}
ul[class^=anchor] > li {
  background-position: 1em .5em;
  background-repeat: no-repeat;
  padding-left: 2em;
}
.pageMessage {
  background: #F6F6F6 25px 15px no-repeat;
  border: 3px solid #fff;
  border-radius: 3px;
  color: #333;
  margin: 10px 0;
  padding: 1em 5.5em;
  position: relative;
}
.pageMessage > h2 {
  font-family:
    Rockwell,
    Arvo,
    serif;
  margin: 0;
}
.pageMessage.debugging {
  background-image: url("./media/tools_32x32.png");
}
.pageMessage.cms {
  background-color: #F5F2ED;
  background-image: url("./media/control_panel_32x32.png");
}
.pageMessage.cms .addNews {
  background: url("./media/document_add_custom_13x16.png") 0 50% no-repeat;
  padding-left: 17px;
}
.pageMessage.cms .addMedia {
  background: url("./media/movie_add_custom_16x16.png") 0 50% no-repeat;
  padding-left: 20px;
}
.pageMessage.switchTemplate {
  background-color: #fff;
  background-image: url("./media/template_32x32.png");
}
.message-box {
  background: #f9f9f9 .615em 1.385em no-repeat;
  border-color: #e8e8e8 #ddd #ddd #e8e8e8;
  border-style: solid;
  border-width: 1px 2px 2px 1px;
  border-radius: 3px;
  box-shadow: 0 0 2em rgba(51, 51, 51, .1) inset;
  box-sizing: border-box;
  font-size: .929em;
  margin: 1.5em 0 .214em;
  min-height: 3em;
  padding: 1px 1em 1em 3em;
  position: relative;
}
.message-box.failure {
  background-color: #FFECEE;
  background-image: url("./media/stop_24x24.png");
}
.message-box.info {
  background-color: #f1f8ff;
  background-image: url("./media/info_24x24.png");
}
.message-box.loading {
  background-color: #f6f6f6;
  background-image: url("./media/loadingCircle.gif");
}
.message-box.success {
  background-color: #E9F9E8;
  background-image: url("./media/confirm_24x24.png");
}
.message-box.warning {
  background-color: #FFEFC5;
  background-image: url("./media/warning_24x24.png");
}
.pageMessage > .close,
.message-box > .close {
  border-radius: 0 0 0 3px;
  color: #333;
  display: block;
  font-size: 1.5384em;
  line-height: 1.2;
  opacity: .33;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-align: center;
  text-decoration: none;
  top: 0;
  transition: .2s linear;
  width: 1em;
}
.pageMessage:hover > .close,
.message-box:hover > .close {
  background: rgba(200, 200, 200, .33);
  opacity: .66;
}
.pageMessage > .close:hover,
.pageMessage > .close:focus,
.message-box > .close:hover,
.message-box > .close:focus {
  background: rgba(200, 200, 200, .66);
  opacity: 1;
}
.join {
  margin-bottom: .214em;
  margin-top: .214em;
}
a[href]:last-child::after {
  font-size: .857em;
}
a[href$=".doc"]:last-child::after,
a[href$=".docm"]:last-child::after,
a[href$=".docx"]:last-child::after,
a[href$=".dot"]:last-child::after,
a[href$=".rtf"]:last-child::after {
  content: " (MS Word)";
}
a[href$=".mp3"]:last-child::after {
  content: " (MP3)";
}
a[href$=".pdf"]:last-child::after {
  content: " (PDF)";
}
a[href$=".pps"]:last-child::after,
a[href$=".ppsx"]:last-child::after,
a[href$=".ppt"]:last-child::after,
a[href$=".pptx"]:last-child::after {
  content: " (MS PowerPoint)";
}
a[href$=".wav"]:last-child::after {
  content: " (WAV)";
}
a[href$=".wmv"]:last-child::after {
  content: " (WMV)";
}
a[href$=".xls"]:last-child::after,
a[href$=".xlsx"]:last-child::after {
  content: " (MS Excel)";
}
a[href$=".zip"]:last-child::after {
  content: " (ZIP)";
}
.header,
.header + .templateContainer,
.footer {
  transition: -webkit-filter .4s linear;
  transition: filter .4s linear;
}
.header.desaturate,
.templateContainer.desaturate,
.footer.desaturate {
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
}
.ui-widget-overlay {
  background: #333;
  opacity: .75;
}
.ui-widget,
.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
  font-family: inherit;
  font-size: inherit;
}
.ui-widget-content {
  background: #fff;
  border: 5px solid #e6e6e6;
  color: #333;
}
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active {
  background-image: none;
  border: 5px solid #e6e6e6;
  transition: .2s linear;
}
.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus {
  background: #e6e6e6;
  color: #333;
}
.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active {
  background: #fff;
  color: #333;
}
.ui-state-active.ui-state-hover,
.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:link:hover,
.ui-state-active a:link:focus,
.ui-state-active a:visited,
.ui-state-active a:visited:hover,
.ui-state-active a:visited:focus {
  color: #333;
  text-decoration: none;
}
.ui-accordion {
  margin: 1.5em 0 .214em;
}
.ui-accordion .ui-accordion-header {
  font-weight: 700;
}
.ui-accordion .ui-state-active {
  border-bottom-width: 3px;
}
.ui-accordion .ui-accordion-content {
  padding: 1px 1em;
}
.ui-autocomplete-loading {
  background-image: url("./media/loadingCircle.gif");
  background-position: 100% 50%;
  background-repeat: no-repeat;
  background-size: 20px 20px;
}
.ui-autocomplete {
  background-clip: padding-box;
  border: 1px solid #003E7E;
  border-radius: 0;
  max-height: 368px;
  max-width: 370px;
  overflow-y: auto;
  padding: 3px;
}
.ui-autocomplete > li {
  background: none;
  padding: 3px 6px;
}
.ui-autocomplete > li:nth-child(even) {
  background: #F3F6F6;
}
.ui-autocomplete a {
  cursor: pointer;
  transition: none;
}
.ui-autocomplete a:hover,
.ui-menu .ui-menu-item a.ui-state-focus {
  background: #001F3F;
  border: 0;
  color: #fff;
  margin: 0;
}
.ui-autocomplete .ui-corner-all {
  border-radius: 0;
}
.ui-datepicker {
  padding: 1em;
}
.ui-datepicker table {
  margin: 0;
}
.ui-dialog {
  background: #e6e6e6;
  border: 0;
  box-shadow: 0 0 100px rgba(255, 255, 255, .66);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  max-width: 99%;
  max-width: -webkit-calc(100% - .5em);
  max-width: -moz-calc(100% - .5em);
  max-width: calc(100% - .5em);
  padding: 5px;
}
.ui-dialog .ui-dialog-titlebar {
  background: #055497;
  border: none;
  border-radius: 3px 3px 0 0;
  color: #fff;
  overflow: hidden;
  padding: 0;
}
.ui-dialog .ui-dialog-title {
  font-size: 1.143em;
  padding: 4px 8px;
  width: -webkit-calc(100% - 44px);
  width: -moz-calc(100% - 44px);
  width: calc(100% - 44px);
}
.ui-dialog .ui-dialog-titlebar-close {
  background: #00194E;
  border: none;
  border-radius: 0 3px 0 0;
  bottom: 0;
  color: #67CCFF;
  height: auto;
  margin: 0;
  padding: 3px 6px;
  right: 0;
  top: 0;
  transition: .2s linear;
  width: auto;
}
.ui-dialog .ui-dialog-titlebar-close:hover {
  background: #111;
  color: #fff;
}
.ui-dialog .ui-button-text {
  font-weight: 700;
  line-height: 1.0714;
  padding: 0;
  text-indent: 0;
}
.ui-dialog.faaModal .ui-button-text {
  font-size: 2em;
}
.ui-dialog .ui-icon {
  background: none;
}
.ui-dialog .ui-dialog-content {
  background: #fff;
  border-radius: 0 0 3px 3px;
  padding: 1px 1em;
}
.ui-dialog .ui-dialog-content:empty {
  background: #fff url("./media/loadingBar.gif") 50% 50% no-repeat;
}
.ui-tabs {
  background: none;
  border: 0;
  padding: 0;
}
.ui-tabs .ui-tabs-nav {
  background: none;
  border: 0;
  color: inherit;
  padding: .214em 0 0 .5em;
}
.ui-tabs .ui-tabs-nav li {
  font-weight: 700;
  margin-top: 0;
  top: 5px;
}
.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
  padding: .214em .429em;
}
.ui-tabs .ui-tabs-nav li.ui-tabs-active {
  margin-bottom: 0;
  padding-bottom: 0;
}
.ui-tabs .ui-tabs-nav .ui-state-hover:not(.ui-state-active) a {
  text-decoration: underline;
}
.ui-tabs .ui-tabs-panel {
  border: 5px solid #e6e6e6;
  border-radius: 6px;
  padding: 1px 1em;
}
.ui-tabs.vertical {
  overflow: hidden;
}
.ui-tabs.vertical > .ui-tabs-nav {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  padding: .5em 0 0;
  width: 27%;
}
.ui-tabs.vertical > .ui-tabs-nav li {
  border-bottom-width: 5px;
  border-right-width: 0;
  border-radius: 4px 0 0 4px;
  float: none;
  margin: 0 -5px .2em 0;
  top: 0;
  white-space: normal;
}
.ui-tabs.vertical > .ui-tabs-nav .ui-tabs-anchor {
  display: block;
  float: none;
  padding: .429em;
}
.ui-tabs.vertical > .ui-tabs-panel {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  float: right;
  width: 73%;
}
@media screen {
  .forPrint {
    display: none;
    visibility: hidden;
  }
}
@media (max-width: 990px) {
  .header {
    margin-bottom: 1em;
  }
  .hNav > ul > li > a {
    font-size: .875rem;
  }
}
@media (max-width: 979px) {
  .mainColumn {
    float: none;
    margin: 0 auto;
  }
  .vNav {
    float: none;
    margin: 0 auto;
    width: 220px;
  }
  .vNav .here {
    background-image: none;
    padding-right: 0;
  }
  .noLeftSidebar > .mainColumn {
    width: 720px;
  }
  .noLeftSidebar .rightSidebar {
    clear: both;
    float: none;
    margin: 0 auto;
  }
  .noRightSidebar #content {
    float: none;
    margin: 0 auto;
  }
  .noSidebars .hGroup {
    float: none;
    width: auto;
  }
  .noSidebars .layout .formRow,
  .noSidebars .layout .formRow.noLabel,
  .noSidebars .layout fieldset {
    padding: 8px 4px;
  }
  .noSidebars .layout label,
  .noSidebars .layout .optionGroup span.label {
    box-sizing: border-box;
    display: block;
    margin-left: 0;
    text-align: left;
    width: auto;
  }
  .noSidebars .layout .caption {
    margin-left: 0;
  }
  .noSidebars .layout .optionGroup legend {
    margin-left: 0;
  }
  .noSidebars .layout .optionGroup label {
    display: inline-block;
    padding-right: 1em;
    width: calc(100% - 1.5em);
  }
  .noSidebars .layout label + input,
  .noSidebars .layout label + select,
  .noSidebars .layout label + textarea {
    max-width: 294px;
  }
}
@media (max-width: 963px) {
  .footer > .threeColumn {
    max-width: 630px;
  }
  .footer > .threeColumn > div:first-child {
    display: none;
  }
  .footer > .threeColumn > div:first-child + div {
    float: left;
    margin-left: 0;
  }
  .footer > .threeColumn > div + div {
    width: 47.308%;
    width: -webkit-calc(50% - 1em);
    width: -moz-calc(50% - 1em);
    width: calc(50% - 1em);
  }
  .footer > .threeColumn > .twoColumn > div {
    float: none;
    width: auto;
  }
}
@media (max-width: 920px) {
  .hNav > ul > li > a {
    padding: 0 6px;
  }
}
@media (max-width: 870px) {
  .topNav > li {
    margin-left: 1em;
  }
}
@media (max-width: 840px) {
  .hNav > ul {
    bottom: 2px;
    margin-bottom: -3px;
  }
  .hNav > ul > li:nth-child(1),
  .hNav > ul > li:nth-child(2),
  .hNav > ul > li:nth-child(3) {
    width: 24%;
  }
  .hNav > ul > li:nth-child(4),
  .hNav > ul > li:nth-child(7) {
    width: 28%;
  }
  .hNav > ul > li:nth-child(5),
  .hNav > ul > li:nth-child(6) {
    width: 36%;
  }
  .hNav > ul > li > a,
  .hNav > ul > li.here > a {
    border-top: 0;
    line-height: 1.642;
    padding: 0;
    text-align: center;
  }
  .hNav > ul > li:hover > div,
  .hNav > ul > li > a:focus + div {
    display: none;
  }
}
@media (max-width: 790px) {
  .topNav {
    margin-top: .5em;
  }
  .topNav > li:nth-child(4) {
    clear: left;
    margin-left: 0;
  }
  .header form {
    margin: .857em 0;
  }
  #q {
    width: 16em;
  }
  .noRightSidebar #content {
    width: auto;
  }
}
@media (max-width: 774px) {
  .default .mainColumn {
    width: 520px;
  }
  .noRightSidebar .mainColumn {
    width: auto;
  }
  .noRightSidebar .layout .formRow,
  .noRightSidebar .layout .formRow.noLabel,
  .noRightSidebar .layout fieldset {
    padding: 8px 4px;
  }
  .noRightSidebar .layout label,
  .noRightSidebar .layout .optionGroup span.label {
    box-sizing: border-box;
    display: block;
    margin-left: 0;
    text-align: left;
    width: auto;
  }
  .noRightSidebar .layout .caption {
    margin-left: 0;
  }
  .noRightSidebar .layout .optionGroup legend {
    margin-left: 0;
  }
  .noRightSidebar .layout .optionGroup label {
    display: inline-block;
    padding-right: 1em;
    width: calc(100% - 1.5em);
  }
  .noRightSidebar .layout label + input,
  .noRightSidebar .layout label + select,
  .noRightSidebar .layout label + textarea {
    max-width: 294px;
  }
  .default .rightSidebar {
    clear: both;
    float: none;
    margin: 0 auto;
  }
  .noRightSidebar .hGroup {
    float: none;
    width: auto;
  }
  .hGroup {
    padding-top: 0;
  }
  .hGroup.tall {
    min-height: 0;
  }
}
@media (max-width: 734px) {
  .noLeftSidebar .mainColumn,
  .noLeftSidebar .hGroup,
  .noLeftSidebar #content {
    float: none;
    width: auto;
  }
  .noLeftSidebar .layout .formRow,
  .noLeftSidebar .layout .formRow.noLabel,
  .noLeftSidebar .layout fieldset {
    padding: 8px 4px;
  }
  .noLeftSidebar .layout label,
  .noLeftSidebar .layout .optionGroup span.label {
    box-sizing: border-box;
    display: block;
    margin-left: 0;
    text-align: left;
    width: auto;
  }
  .noLeftSidebar .layout .caption {
    margin-left: 0;
  }
  .noLeftSidebar .layout .optionGroup legend {
    margin-left: 0;
  }
  .noLeftSidebar .layout .optionGroup label {
    display: inline-block;
    padding-right: 1em;
    width: calc(100% - 1.5em);
  }
  .noLeftSidebar .layout label + input,
  .noLeftSidebar .layout label + select,
  .noLeftSidebar .layout label + textarea {
    max-width: 294px;
  }
}
@media (max-width: 610px) {
  .pageMessage {
    background-image: none !important;
    padding: 1em;
  }
  .pageMessage > h2 {
    margin-top: 0 !important;
  }
}
@media (max-width: 560px) {
  .header,
  .hGroup {
    margin-bottom: .5em;
  }
  .siteLogo {
    border-radius: 3px;
    display: table;
    float: none;
    height: 42px;
    margin: 0 auto .5em;
    overflow: hidden;
    padding: .5em 0;
  }
  .siteLogo > .left {
    width: 42px;
  }
  .siteLogo > span {
    margin: 0;
  }
  .topNav {
    float: none;
    font-size: .929em;
    margin: .5em auto 1em;
    text-align: center;
  }
  .topNav > li,
  .topNav > li:nth-child(4) {
    display: inline-block;
    float: none;
    margin: 0;
  }
  .topNav > li > a {
    padding: 0 14px;
  }
  .header form {
    float: none;
    margin: .5em auto 1em;
    text-align: center;
  }
  #q {
    box-sizing: border-box;
    max-width: calc(100% - 5.5em - 4px);
  }
}
@media (max-width: 530px) {
  button,
  input,
  optgroup,
  select,
  textarea {
    font-size: 1rem;
  }
  .topNav {
    max-width: 310px;
  }
  .default .mainColumn,
  .default .hGroup,
  .noRightSidebar .hGroup,
  .default #content {
    width: 100%;
  }
  .default .layout .formRow,
  .default .layout .formRow.noLabel,
  .default .layout fieldset {
    padding: 8px 4px;
  }
  .default .layout label,
  .default .layout .optionGroup span.label {
    box-sizing: border-box;
    display: block;
    margin: 0;
    text-align: left;
    width: auto;
  }
  .default .layout .caption,
  .default .layout .optionGroup legend {
    margin-left: 0;
  }
  .default .layout .optionGroup label {
    display: inline-block;
    padding-right: 1em;
    width: calc(100% - 1.5em);
  }
  .default .layout label + input,
  .default .layout label + select,
  .default .layout label + textarea {
    max-width: 289px;
  }
  .content img.left:not(.keepFloated),
  .content img.right:not(.keepFloated),
  .image.left:not(.keepFloated),
  .image.right:not(.keepFloated) {
    box-sizing: border-box;
    display: block;
    float: none;
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 515px) {
  code,
  samp {
    padding: 2px;
  }
  .hNav > ul > li > a {
    font-weight: 400;
  }
  .threeColumn > div,
  .threeColumn > div:first-child + div,
  .threeColumn > div + div + div {
    float: none;
    margin-left: 0;
    width: auto;
  }
}
@media (max-width: 440px) {
  .hNav > ul {
    max-width: 320px;
  }
  .hNav > ul > li:nth-child(odd),
  .hNav > ul > li:nth-child(even) {
    width: auto;
  }
  .hNav > ul > li > a {
    padding: 0 14px;
    text-align: left;
  }
  @supports (display: flex) {
    .hNav > ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .hNav > ul > li {
      flex-grow: 1;
    }
  }
  .twoColumn > div,
  .twoColumn > div + div {
    float: none;
    width: auto;
  }
  .footer > div + div > div,
  .footer > div + div > div + div {
    width: auto;
  }
  .ui-autocomplete {
    display: none !important;
  }
}
@media (max-width: 375px) {
  .siteLogo {
    height: 22px;
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .siteLogo > .left {
    width: 22px;
  }
  .siteLogo > span {
    display: inline;
    font-size: 1em;
    line-height: 1;
    width: auto;
  }
}
@media (max-width: 360px) {
  .pageTools > li {
    margin: 4px .5em;
  }
}
@media print {
  * {
    background: transparent !important;
    box-shadow: none !important;
    color: #000 !important;
    text-shadow: none !important;
  }
  a {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ") ";
    white-space: normal;
    word-wrap: break-word;
  }
  a[href^="#"]:after,
  a[href^="."]:after,
  a.siteLogo:after {
    content: "";
  }
  abbr[title]:after,
  acronym[title]:after {
    content: " (" attr(title) ")";
    font-size: .857em;
  }
  blockquote,
  pre {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  .skipLinks,
  .topNav,
  .header form,
  .hNav,
  .vNav,
  .breadcrumbs,
  .rightSidebar,
  .footer,
  .noPrint {
    display: none;
  }
  .siteLogo {
    font-size: 1.5rem;
    height: auto;
    padding-top: 0;
    width: auto;
  }
  .hGroup {
    border-top: 0;
  }
  .templateContainer,
  .mainColumn,
  #content {
    float: none;
    width: auto !important;
  }
  #content {
    border-top: 1px solid #ddd;
  }
  ul[class^=anchor] {
    padding-left: 2em;
  }
  ul[class^=anchor] > li {
    padding-left: 0;
  }
  a.anchorUp,
  a.anchor-up,
  .anchor-up > li,
  .anchorUp > li,
  a.anchorDown,
  a.anchor-down,
  .anchor-down > li,
  .anchorDown > li {
    background: none;
  }
  a.anchorUp,
  a.anchor-up,
  a.anchorDown,
  a.anchor-down {
    padding-left: 0;
  }
}
/*# sourceMappingURL=main.css.map */
